import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WhitelabelService } from '@galaxy/partner';

@Injectable({ providedIn: 'root' })
export class BrandingService {
  constructor(private readonly whiteLabelService: WhitelabelService) {}

  getBusinessAppName(partnerId: string, marketId: string): Observable<string> {
    return this.whiteLabelService.getBranding(partnerId, marketId).pipe(
      map((branding) => branding?.apps['VBC']?.name),
      catchError((err) => {
        console.error(err);
        return of('');
      }),
    );
  }
}
